import Phaser from 'phaser';
import {
  MINIGAME_FOOD,
  STATE_MINIGAME_FOOD,
  STATE_MINIGAME_CHASE,
} from '../constants/AppConstants';
import ScreenContainer from '../display/ui/ScreenContainer';
import LoadDisplay from '../display/ui/LoadDisplay';
import { UnloadAssetPack } from '../../utils/AssetpackUnloader';

export default class MiniGameLoader extends Phaser.State {
  init({ minigameid, locationid }) {
    this.minigameid = minigameid;
    this.locationid = locationid;
  }

  preload() {
    // ditch out last assets
    UnloadAssetPack(this.game, MiniGameLoader.PreviousAssetPack);

    // store everything in a container, it will reposition for screen
    this.container = new ScreenContainer(this.game, {
      background: 'background_generic',
      overlay: true,
    });
    this.game.add.existing(this.container);

    this.loadDisplay = new LoadDisplay(this.game, true);
    this.loadDisplay.x = this.game.defaultWidth * 0.5 - this.loadDisplay.width * 0.5;
    this.loadDisplay.y = this.game.defaultHeight * 0.5 - this.loadDisplay.height * 0.5;
    this.container.add(this.loadDisplay);

    this.assetsLoaded = false;

    if (this.minigameid == MINIGAME_FOOD) {
      this.loadFoodMiniGame();
    } else {
      this.loadChaseMiniGame();
    }

    this.game.load.onFileComplete.add(this.fileComplete, this);
  }

  loadFoodMiniGame() {
    this.game.load.baseURL = './assets/foodgame/';
    this.game.load.crossOrigin = 'anonymous';
    this.game.load.pack('general', 'assetpack.json', null, this);
    this.game.load.pack(this.locationid, 'assetpack.json', null, this);
    this.game.load.json('minigameassets', 'assetpack.json', null, this);

    // generate local assetpack
    this.localAsssets = {
      assets: [
        {
          type: 'audiosprite',
          key: 'foodgame_vo',
          urls: [
            '../locale/' + this.game.language + '/audio/foodgame_vo.m4a',
            '../locale/' + this.game.language + '/audio/foodgame_vo.ogg',
            '../locale/' + this.game.language + '/audio/foodgame_vo.mp3',
          ],
          jsonURL: '../locale/' + this.game.language + '/audio/foodgame_vo.json',
          jsonData: null,
          autoDecode: true,
        },
      ],
    };

    this.game.load.pack('assets', null, this.localAsssets);
  }

  loadChaseMiniGame() {
    this.game.load.baseURL = './assets/chasegame/';
    this.game.load.crossOrigin = 'anonymous';
    this.game.load.pack('general', 'assetpack.json', null, this);
    this.game.load.pack(this.locationid, 'assetpack.json', null, this);
    this.game.load.json('minigameassets', 'assetpack.json', null, this);
  }

  fileComplete(progress, cacheKey, success, totalLoaded, totalFiles) {
    this.loadDisplay.progress = progress;
  }

  create() {
    MiniGameLoader.PreviousAssetPack = this.game.cache.getJSON('minigameassets', true);
    this.assetsLoaded = true;

    Object.keys(MiniGameLoader.PreviousAssetPack).forEach((key) => {
      const assets = MiniGameLoader.PreviousAssetPack[key];
      assets.forEach((item) => {
        switch (item.type) {
          case 'audiosprite':
            this.game.sounds.addAudioSprite({ id: item.key });
            break;
          case 'audio':
            this.game.sounds.addSound(item.key, item.key);
            break;
        }
      });
    });

    // register vo
    if (this.localAsssets) {
      Object.keys(this.localAsssets).forEach((key) => {
        const assets = this.localAsssets[key];
        assets.forEach((item) => {
          switch (item.type) {
            case 'audiosprite':
              this.game.sounds.addAudioSprite({ id: item.key });
              break;
          }
        });
      });
    }
  }

  update() {
    if (this.assetsLoaded) {
      if (this.game.sounds.soundsAreDecoded()) {
        this.game.sounds.checkAudioContext();
        const state = this.minigameid == MINIGAME_FOOD ? STATE_MINIGAME_FOOD : STATE_MINIGAME_CHASE;
        this.game.state.start(state, true, false, { locationid: this.locationid });
      }
    }
  }

  shutdown() {
    this.game.load.onFileComplete.remove(this.fileComplete, this);
    this.loadDisplay.destroy();
    this.loadDisplay = null;
    this.container.destroy();
    this.container = null;
  }
}

MiniGameLoader.PreviousAssetPack = {};



// WEBPACK FOOTER //
// ./js/app/states/MiniGameLoader.js